<template>
  <div class="hero-container">
    <img src="@/assets/logo.png" alt="Logo" class="main-logo" />

    <button class="start-button" @click="volverInicio">
      ¡Gracias por participar!
    </button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      redireccionCancelada: false,
      timeoutID: null,
    };
  },
  methods: {
    volverInicio() {
      this.redireccionCancelada = true; // Marca que el usuario ya tomó acción
      clearTimeout(this.timeoutID); // Cancela el timeout si sigue activo
      this.$store.dispatch('clearData');
      this.$router.push('/');
    },
  },
  mounted() {
    this.timeoutID = setTimeout(() => {
      if (!this.redireccionCancelada) {
        this.volverInicio();
      }
    }, 10000); // 10 segundos
  },
};
</script>

<style lang="scss" scoped>
.hero-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #0095d9;
  height: 100vh;
  width: 100vw;
  font-family: 'FormaDJRDisplay', sans-serif;
  position: relative;
  padding: 20px;
  box-sizing: border-box;
}

.main-logo {
  width: 60vw;
  max-width: 360px;
  height: auto;
  margin-bottom: 3rem;
}

.start-button {
  font-size: 1.8rem;
  color: white;
  background-color: transparent;
  border-top: 1px solid white;
  border-bottom: 1px solid white;
  padding: 0.75rem 2rem;
  width: 100vw;
  position: absolute;
  bottom: 5%;
  left: 0;
  right: 0;
  margin: auto;
  display: block;
  cursor: pointer;
  transition: background-color 0.3s, color 0.3s;

  &:hover {
    background-color: white;
    color: #0095d9;
  }
}
</style>
